import React from "react";
import { ShoppingBag, TrendingUp, Gift, DoorOpen } from "lucide-react";
import { T, STATE } from "./theme";

const DOORS = {
  purchases: { icon: ShoppingBag, title: "Novas compras", text: "Conheça as novidades da Cris Lingerie. Novas compras seguem a análise da sua revendedora.", cta: "Conhecer novidades" },
  limit: { icon: TrendingUp, title: "Evolução de limite", text: "Um bom histórico pode contribuir para análises futuras do seu limite.", cta: "Entenda seu limite" },
  benefits: { icon: Gift, title: "Benefícios exclusivos", text: "Espaço reservado para campanhas destinadas a clientes com bom histórico.", cta: "Ver benefícios" },
};

export const OpportunityDoors = ({ items, onAction }) => (
  <section data-testid="opportunities-section">
    <div className="flex items-center gap-2 px-1">
      <DoorOpen size={20} style={{ color: T.violet }} />
      <h2 className="text-[17px] font-extrabold" style={{ color: T.deep }}>Suas portas de oportunidades</h2>
    </div>
    <p className="px-1 text-[14px]" style={{ color: T.muted }}>Um bom histórico pode abrir novos caminhos para você.</p>
    <div className="mt-3 grid gap-3 sm:grid-cols-3">
      {items.map((o) => {
        const d = DOORS[o.key]; const st = STATE[o.state] || STATE.unavailable; const Icon = d.icon;
        return (
          <article key={o.key} className="flex flex-col rounded-[22px] p-4 transition-transform duration-200 hover:-translate-y-0.5"
            style={{ background: `linear-gradient(160deg, ${T.rose} 0%, ${T.lavender} 100%)` }} data-testid={`door-${o.key}`}>
            <div className="flex flex-1 items-start gap-3 sm:flex-col">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white" style={{ color: T.roseInk }}><Icon size={21} /></span>
              <div className="min-w-0 flex-1">
                <h3 className="text-[16px] font-extrabold" style={{ color: T.deep }}>{d.title}</h3>
                <span className="mt-1 inline-block rounded-full px-2.5 py-0.5 text-[11px] font-bold" style={{ background: st.bg, color: st.fg }} data-testid={`door-${o.key}-state`}>{st.label}</span>
                <p className="mt-1.5 text-[13px] leading-snug" style={{ color: T.muted }}>{d.text}</p>
              </div>
            </div>
            <button onClick={() => onAction(o.key)} className="mt-3 rounded-xl bg-white py-2.5 text-[14px] font-bold transition-colors hover:bg-[#FFF8FC]"
              style={{ color: T.violet }} data-testid={`door-${o.key}-btn`}>{d.cta}</button>
          </article>
        );
      })}
    </div>
  </section>
);
